import { action, makeObservable, observable, runInAction, observe } from 'mobx';
import { getReceiptList } from '../api/admin';
import { IS_STAGING } from '../environment';
import Receipt from '../model/Receipt';
import CompanyStore from './CompanyStore';

const ROWS_PER_PAGE = 15;

class ReceiptStore {
  companyStore: CompanyStore;

  list: Receipt[] = [];

  endReached = false;

  loading = false;

  constructor(companyStore: CompanyStore) {
    this.companyStore = companyStore;
    makeObservable(this, {
      list: observable,
      loading: observable,
      fetchInitialReceipts: action,
      refreshReceipts: action,
    });
    observe(this.companyStore, 'companyKey', async ({ newValue }) => {
      if (newValue) {
        this.initialize();
      } else {
        this.clear();
      }
    });
  }

  async initialize() {
    if (!this.companyStore.companyKey) {
      return;
    }
    runInAction(() => {
      this.list = [];
      this.fetchInitialReceipts();
    });
  }

  clear() {
    this.list = [];
  }

  fetchInitialReceipts() {
    if (!this.companyStore.companyKey || this.loading || this.list.length !== 0) {
      return;
    }
    this.endReached = false;
    this.loading = true;
    getReceiptList(this.companyStore.companyKey).then((res) => {
      if (res.length < ROWS_PER_PAGE) {
        this.endReached = true;
      }

      runInAction(() => {
        this.list = res;
        this.loading = false;
      });
    });
  }

  fetchMoreReceipts() {
    if (!this.companyStore.companyKey || this.loading || this.endReached) {
      return;
    }
    this.loading = true;
    getReceiptList(this.companyStore.companyKey, this.list.length)
      .then((res) => {
        runInAction(() => {
          if (res.length < 25) {
            this.endReached = true;
          }
          this.list = [...this.list, ...res];
        });
      })
      .finally(() => {
        runInAction(() => {
          this.loading = false;
        });
      });
  }

  refreshReceipts() {
    if (this.loading) {
      return;
    }
    this.list = [];
    this.fetchInitialReceipts();
  }

  getFirebaseLink(receipt: Receipt) {
    return IS_STAGING
      ? `https://console.firebase.google.com/u/0/project/enklakassan-staging/firestore/data/~2Fcompanies~2F${this.companyStore.companyKey}~2Freceipts~2F${receipt.paymentID}`
      : `https://console.firebase.google.com/u/0/project/enkla-kassan/firestore/data/~2Fcompanies~2F${this.companyStore.companyKey}~2Freceipts~2F${receipt.paymentID}`;
  }
}

export default ReceiptStore;
